import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrderCancelParams } from '~/types/order.types';

const usePostOrderCancel = () => {
  const endpoint = '/api-oms/order/cancel';

  const postOrderCancel = async (params: TypePostOrderCancelParams) => {
    return axiosInstance
      .post(endpoint, params)
      .then((data) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOrderCancel };
};

export default usePostOrderCancel;
